import React from "react";
import clsx from "clsx";
import { motion } from "framer-motion";

interface HappyCustomersCardProps {
  quote: string;
  name: string;
  organization: string;
  carouselIndex?: number;
}

const HappyCustomersCard: React.FC<HappyCustomersCardProps> = ({
  quote,
  name,
  organization,
  carouselIndex,
}) => {
  // Use a unique ID for each card's animation
  const uniqueId = React.useMemo(
    () => `quote-${name}-${carouselIndex}`,
    [name, carouselIndex]
  );

  return (
    <div
      className={clsx(
        "flex",
        "flex-col",
        "md:flex-row",
        "items-center",
        "gap-8",
        "p-4",
        "md:px-8",
        "lg:px-12",
        "h-full" // Ensure full height for the parent container
      )}
    >
      <div
        className={clsx(
          "flex-grow",
          "h-full",
          "max-w-2xl",
          "flex",
          "flex-col",
          "justify-start"
        )}
      >
        <div className={clsx("flex", "flex-col", "top")}>
          <div>
            <motion.div
              className="relative overflow-hidden"
              layoutId={`quote-container-${uniqueId}`}
              transition={{
                duration: 0.4,
                ease: "easeInOut",
                layout: { duration: 0.3 },
              }}
            >
              <motion.p
                layoutId={`quote-text-${uniqueId}`}
                className={clsx(
                  "text-lg",
                  "text-gray-700",
                  "mb-2",
                  "whitespace-pre-wrap",
                  "leading-6"
                )}
              >
                {`"${quote}"`}
              </motion.p>
            </motion.div>
          </div>
          <div className={clsx("flex", "flex-col", "!font-sans")}>
            <p className={clsx("text-base", "font-bold")}>{name}</p>
            <p className={clsx("text-base", "font-bold")}>{organization}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HappyCustomersCard;
